import { render, staticRenderFns } from "./JobTitleBlock.vue?vue&type=template&id=235c2972&scoped=true&"
import script from "./JobTitleBlock.vue?vue&type=script&lang=ts&"
export * from "./JobTitleBlock.vue?vue&type=script&lang=ts&"
import style0 from "./JobTitleBlock.vue?vue&type=style&index=0&id=235c2972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c2972",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAvatar,VBtn,VChip,VCol,VIcon,VRow,VSnackbar})
